import { makeServicesTypesFromEnum } from '@/core/container/makeServicesTypes'

export enum GOOGLE_SERVICES {
  GoogleMapsJsApiLoaderService,
  GooglePlacesAutocompleteService,
}

export type GoogleServices = keyof typeof GOOGLE_SERVICES

export const GOOGLE_SERVICES_TYPES = makeServicesTypesFromEnum<GoogleServices>(GOOGLE_SERVICES)
